
      <div class="ui-g-12 sf-field-container flex-align-center">
        <div class="ui-g-12 ui-md-4">
          <span class="label">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-8">
          <p-checkbox
            [name]="name"
            [formControl]="control"
            [binary]="true"
            [disabled]="schema.readOnly||false"
          ></p-checkbox>
        </div>
      </div>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/checkbox.widget.ts.CheckboxWidget.html